export class MarketNewsContentEntity {
    constructor(newsTime, title, imageUrl, source) {
        this.newsTime = newsTime;
        this.title = title;
        this.imageUrl = imageUrl;
        this.source = source;
    }
}
